import React from 'react';
import styled from 'styled-components/macro';

import { UserAgent } from '@mirinae/js-utils';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { FormattedKoEnPhrase } from '@mirinae/lessons/components/lesson/elements/Phrase';

import PlusSVG from '@mirinae/lessons/assets/images/plus.svg';
import ArrowSVG from '@mirinae/lessons/assets/images/arrow.svg';
import SmallArrowSVG from '@mirinae/lessons/assets/images/smallArrow.svg';

const isMobile = !UserAgent.os.isOthers;

const PatternWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const Pattern = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const Becomes = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const Plus = styled.div`
    padding:  ${props => props.plusPad};
`;

const Arrow = styled.div`
`;

const ArrowAndAnnotation = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${props => props.arrowPad};
    width: fit-content;
    align-items: center;
`;

const ChangeAnnotation = styled.div`
    padding-top: 0px;
`;

const staticStyle = {
    koFontWeight: '700', koreanFontSize: '30px',
    enFontWeight: '500', englishFontSize: '15px',
    align: 'center',
};

export const FormattedStaticPattern = ({ base, pattern, becomes, change, style = staticStyle }) => {
    const fontSize = parseInt(style.koreanFontSize, 10);
    const plusPad = `0px ${fontSize * 0.75}px 0 ${fontSize * 0.75}px`;
    const arrowPad = `0px ${fontSize * 0.75}px 0 ${fontSize * 0.75}px`;

    return (
        <PatternWrapper>
            {base && !base.hidden && (
                <FormattedKoEnPhrase phrase={base} phraseStyle={style} />
            )}
            {!isMobile && pattern && !pattern.hidden && (
                <Pattern>
                    <Plus plusPad={plusPad}><img src={PlusSVG} alt="+" /></Plus>
                    <FormattedKoEnPhrase phrase={pattern} phraseStyle={style} />
                </Pattern>
            )}
            {becomes && !becomes.hidden && (
                <Becomes>
                    <ArrowAndAnnotation arrowPad={arrowPad}>
                        <Arrow>{!isMobile && change ? <img src={ArrowSVG} alt="Arrow" /> : <img src={SmallArrowSVG} alt="Arrow" />}</Arrow>
                        {!isMobile && change && !change.hidden && <ChangeAnnotation>{change.value}</ChangeAnnotation>}
                    </ArrowAndAnnotation>
                    <FormattedKoEnPhrase phrase={becomes} phraseStyle={style} />
                </Becomes>
            )}
        </PatternWrapper>
    );
};

const StaticPattern = ({ element }) => {
    return (
        <Element element={element}>
            <FormattedStaticPattern
                base={element.fieldsByName.base}
                pattern={element.fieldsByName.pattern}
                becomes={element.fieldsByName.becomes}
                change={element.fieldsByName.change}
                style={staticStyle}
            />
        </Element>
    );
};

export default StaticPattern;
